import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = ["onClick"];
var _hoisted_2 = {
  "class": "list-item-text"
};
import TUIChatEngine, { TUIStore, StoreName, TUITranslateService } from "@tencentcloud/chat-uikit-engine";
import { ref, watchEffect, computed } from "../../../../adapter-vue";
import { isPC, isUniFrameWork } from "../../../../utils/env";
import { TUIGlobal } from "../../../../utils/universal-api/index";
import Icon from "../../../common/Icon.vue";
import { Toast, TOAST_TYPE } from "../../../common/Toast/index";
import delIcon from "../../../../assets/icon/msg-del.svg";
import copyIcon from "../../../../assets/icon/msg-copy.svg";
import quoteIcon from "../../../../assets/icon/msg-quote.svg";
import revokeIcon from "../../../../assets/icon/msg-revoke.svg";
import forwardIcon from "../../../../assets/icon/msg-forward.svg";
import { enableSampleTaskStatus } from "../../../../utils/enableSampleTaskStatus";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    messageItem: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    isShowTool: {
      type: Boolean,
      "default": false
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var TYPES = TUIChatEngine.TYPES;
    var actionItems = [{
      text: TUITranslateService.t("TUIChat.打开"),
      iconUrl: copyIcon,
      renderCondition: function renderCondition() {
        var _message$value, _message$value2, _message$value3;
        if (!message.value) return false;
        return isPC && (((_message$value = message.value) === null || _message$value === void 0 ? void 0 : _message$value.type) === TYPES.MSG_FILE || ((_message$value2 = message.value) === null || _message$value2 === void 0 ? void 0 : _message$value2.type) === TYPES.MSG_VIDEO || ((_message$value3 = message.value) === null || _message$value3 === void 0 ? void 0 : _message$value3.type) === TYPES.MSG_IMAGE);
      },
      clickEvent: openMessage
    }, {
      text: TUITranslateService.t("TUIChat.复制"),
      iconUrl: copyIcon,
      renderCondition: function renderCondition() {
        var _message$value4;
        if (!message.value) return false;
        return isUniFrameWork && ((_message$value4 = message.value) === null || _message$value4 === void 0 ? void 0 : _message$value4.type) === TYPES.MSG_TEXT;
      },
      clickEvent: copyMessage
    }, {
      text: TUITranslateService.t("TUIChat.撤回"),
      iconUrl: revokeIcon,
      renderCondition: function renderCondition() {
        var _message$value5, _message$value6;
        if (!message.value) return false;
        return ((_message$value5 = message.value) === null || _message$value5 === void 0 ? void 0 : _message$value5.flow) === "out" && ((_message$value6 = message.value) === null || _message$value6 === void 0 ? void 0 : _message$value6.status) === "success";
      },
      clickEvent: revokeMessage
    }, {
      text: TUITranslateService.t("TUIChat.删除"),
      iconUrl: delIcon,
      renderCondition: function renderCondition() {
        var _message$value7;
        if (!message.value) return false;
        return ((_message$value7 = message.value) === null || _message$value7 === void 0 ? void 0 : _message$value7.status) === "success";
      },
      clickEvent: deleteMessage
    }, {
      text: TUITranslateService.t("TUIChat.转发"),
      iconUrl: forwardIcon,
      renderCondition: function renderCondition() {
        var _message$value8;
        if (!message.value) return false;
        return ((_message$value8 = message.value) === null || _message$value8 === void 0 ? void 0 : _message$value8.status) === "success";
      },
      clickEvent: forwardSingleMessage
    }, {
      text: TUITranslateService.t("TUIChat.引用"),
      iconUrl: quoteIcon,
      renderCondition: function renderCondition() {
        var _message$value9;
        if (!message.value) return false;
        var _message = TUIStore.getMessageModel(message.value.ID);
        return ((_message$value9 = message.value) === null || _message$value9 === void 0 ? void 0 : _message$value9.status) === "success" && !_message.getSignalingInfo();
      },
      clickEvent: quoteMessage
    }];
    var message = ref();
    watchEffect(function () {
      message.value = TUIStore.getMessageModel(props.messageItem.ID);
    });
    var isAllActionItemInvalid = computed(function () {
      for (var i = 0; i < actionItems.length; ++i) {
        if (actionItems[i].renderCondition()) {
          return false;
        }
      }
      return true;
    });
    function getFunction(index) {
      // 兼容 vue2 小程序的写法 不允许动态绑定
      actionItems[index].clickEvent();
    }
    function openMessage() {
      var _message$value10, _window;
      var url = "";
      switch ((_message$value10 = message.value) === null || _message$value10 === void 0 ? void 0 : _message$value10.type) {
        case TUIChatEngine.TYPES.MSG_FILE:
          url = message.value.payload.fileUrl;
          break;
        case TUIChatEngine.TYPES.MSG_VIDEO:
          url = message.value.payload.remoteVideoUrl;
          break;
        case TUIChatEngine.TYPES.MSG_IMAGE:
          url = message.value.payload.imageInfoArray[0].url;
          break;
      }
      (_window = window) === null || _window === void 0 || _window.open(url, "_blank");
    }
    function revokeMessage() {
      if (!message.value) return;
      // 获取 messageModel
      var messageModel = TUIStore.getMessageModel(message.value.ID);
      messageModel.revokeMessage().then(function () {
        enableSampleTaskStatus('revokeMessage');
      })["catch"](function (error) {
        // 调用异常时业务侧可以通过 promise.catch 捕获异常进行错误处理
        if (error.code = 20016) {
          var _message2 = TUITranslateService.t("TUIChat.已过撤回时限");
          Toast({
            message: _message2,
            type: TOAST_TYPE.ERROR
          });
        }
      });
    }
    function deleteMessage() {
      if (!message.value) return;
      // 获取 messageModel
      var messageModel = TUIStore.getMessageModel(message.value.ID);
      messageModel.deleteMessage();
    }
    function copyMessage() {
      if (isUniFrameWork) {
        var _message$value11;
        TUIGlobal === null || TUIGlobal === void 0 || TUIGlobal.setClipboardData({
          data: (_message$value11 = message.value) === null || _message$value11 === void 0 || (_message$value11 = _message$value11.payload) === null || _message$value11 === void 0 ? void 0 : _message$value11.text
        });
      }
    }
    function forwardSingleMessage() {
      if (!message.value) return;
      TUIStore.update(StoreName.CUSTOM, "singleForwardMessageID", message.value.ID);
    }
    function quoteMessage() {
      if (!message.value) return;
      message.value.quoteMessage();
    }
    return function (_ctx, _cache) {
      return !_unref(isAllActionItemInvalid) && !__props.messageItem.hasRiskContent ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "class": _normalizeClass(["dialog-item", !_unref(isPC) ? 'dialog-item-h5' : 'dialog-item-web'])
      }, [_createElementVNode("div", {
        "class": _normalizeClass(["dialog-item-list", !_unref(isPC) ? 'dialog-item-list-h5' : 'dialog-item-list-web'])
      }, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(actionItems, function (item, index) {
        return _openBlock(), _createElementBlock(_Fragment, null, [item.renderCondition() ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          "class": "list-item",
          onClick: function onClick($event) {
            return getFunction(index);
          }
        }, [_createVNode(Icon, {
          file: item.iconUrl,
          width: "15px",
          height: "15px"
        }, null, 8, ["file"]), _createElementVNode("span", _hoisted_2, _toDisplayString(item.text), 1)], 8, _hoisted_1)) : _createCommentVNode("", true)], 64);
      }), 64))], 2)], 2)) : _createCommentVNode("", true);
    };
  }
});